import PageHeader from 'common/components/PageHeader/PageHeader';
import AlertsContext from 'common/contexts/alerts';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import JobForm from 'requests/pages/Jobs/JobForm';
import useItem from '../../../common/hooks/useItem';

const Job = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { id: jobId } = router.match.params;
  const {
    saveItem, updateItem, item, error,
  } = useItem('jobs', jobId);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      if (router.history.action === 'POP') {
        router.push('/jobs');
      } else {
        router.history.goBack();
      }
    } else {
      setAlert(error, 'danger');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(async (data) => {
    const job = { ...data };

    if (job.id) {
      await updateItem(job.id, job);
      back();
    } else {
      await saveItem(job);
      back();
    }
  }, [updateItem, back, saveItem]);

  return (
    <>
      <PageHeader
        title={t(`common.${item && item.id ? 'edit' : 'add'}`)}
        subLink={{
          url: '/jobs',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section form-page has-cards">
        <JobForm onSubmit={onSubmit} job={item} />
      </section>
    </>
  );
};

export default Job;
